import { call, put, takeLatest } from "redux-saga/effects";
import { ActionWithPayload } from "@shared/interfaces";
import { startLoading, stopLoading } from "@shared/store/actions";

import { AuditLogDetail, AuditLogFilter, AuditLogFilterOptions, AuditLogListResponse } from "../interfaces";
import { getAuditLogDetail, getAuditLogFilters, getAuditLogs } from "./actions";
import { toAuditLogRequestError } from "./requestError";
import api from "../api";

export function* getAuditLogsSaga({ payload }: ActionWithPayload<AuditLogFilter>) {
  try {
    yield put(startLoading());
    const response: AuditLogListResponse = yield call(api.getAuditLogs, payload);
    yield put(stopLoading());
    yield put(getAuditLogs.success(response));
  } catch (error) {
    yield put(getAuditLogs.failure(toAuditLogRequestError(error)));
    yield put(stopLoading());
  }
}

// No startLoading/stopLoading here -- the filter selects populate quietly in the background and
// must not drive the list's own busy state (the AuditLogList loader name only watches getAuditLogs).
export function* getAuditLogFiltersSaga() {
  try {
    const response: AuditLogFilterOptions = yield call(api.getAuditLogFilters);
    yield put(getAuditLogFilters.success(response));
  } catch (error) {
    yield put(getAuditLogFilters.failure(toAuditLogRequestError(error)));
  }
}

export function* getAuditLogDetailSaga({ payload }: ActionWithPayload<number>) {
  try {
    yield put(startLoading());
    const response: AuditLogDetail = yield call(api.getAuditLogById, payload);
    yield put(stopLoading());
    yield put(getAuditLogDetail.success(response));
  } catch (error) {
    yield put(getAuditLogDetail.failure(toAuditLogRequestError(error)));
    yield put(stopLoading());
  }
}

function* auditLogSagas() {
  yield takeLatest(getAuditLogs.request, getAuditLogsSaga);
  yield takeLatest(getAuditLogFilters.request, getAuditLogFiltersSaga);
  yield takeLatest(getAuditLogDetail.request, getAuditLogDetailSaga);
}

export default auditLogSagas;
